// extracted by mini-css-extract-plugin
export default {"container":"MessagePopupNew_container__viQ8q","startDemoButton":"MessagePopupNew_startDemoButton__pNEhw"};